import type { PropsWithChildren } from 'react';

import type { DrawerProps } from '../../components/game/drawer/Drawer';
import type { ModalProps } from '../../components/modal/modal/Modal';

export enum BottomSheetInstance {
  Statistics = 'Statistics',
  Autoplay = 'Autoplay',
}

export type BottomSheetVariant = 'modal' | 'drawer';

export interface BottomSheetConnectedProps extends PropsWithChildren {
  title: string;
  instance: BottomSheetInstance;
  variant: BottomSheetVariant;
}

export interface BottomSheetInstanceProps extends Omit<BottomSheetConnectedProps, 'variant'> {}

export interface BottomSheetModalConnectedProps
  extends BottomSheetInstanceProps,
    Omit<ModalProps, 'title' | 'open' | 'newLayout'> {}

export interface BottomSheetDrawerConnectedProps
  extends BottomSheetInstanceProps,
    Omit<DrawerProps, 'open' | 'title'> {}
